import apis from '../apis/apis'
import hanhDongChinhSua from '../constant/hanhDongChinhSua'

const chinhSuaVanBangProcessor = {}
const controllerName = 'ChinhSuaVanBang'

chinhSuaVanBangProcessor.getVanBangChinhSuaTrinhDuyetByState = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
  state = hanhDongChinhSua.trinhDuyet,
}) => {
  const rs = await apis[controllerName].GetVanBangChinhSua({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&donViDangKyDuThiId=${donViDangKyDuThiId}&heDaoTaoId=${heDaoTaoId}&hinhThucDaoTaoId=${hinhThucDaoTaoId}&name=${name}&state=${state}`,
  })
  return rs.isSuccess ? rs.data : { skip, take, values: [], total: 0 }
}

chinhSuaVanBangProcessor.getVanBangChinhSuaTrinhDuyet = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  return chinhSuaVanBangProcessor.getVanBangChinhSuaTrinhDuyetByState({
    khoaThiId,
    skip,
    take,
    donViDangKyDuThiId,
    heDaoTaoId,
    hinhThucDaoTaoId,
    name,
    state: hanhDongChinhSua.trinhDuyet,
  })
}

chinhSuaVanBangProcessor.getVanBangChinhSuaDaDuyet = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  return chinhSuaVanBangProcessor.getVanBangChinhSuaTrinhDuyetByState({
    khoaThiId,
    skip,
    take,
    donViDangKyDuThiId,
    heDaoTaoId,
    hinhThucDaoTaoId,
    name,
    state: hanhDongChinhSua.dongY,
  })
}
chinhSuaVanBangProcessor.getVanBangChinhSuaChoDuyet = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  return chinhSuaVanBangProcessor.getVanBangChinhSuaTrinhDuyetByState({
    khoaThiId,
    skip,
    take,
    donViDangKyDuThiId,
    heDaoTaoId,
    hinhThucDaoTaoId,
    name,
    state: hanhDongChinhSua.choDuyet,
  })
}
chinhSuaVanBangProcessor.getVanBangChinhSuaHistory = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  const rs = await apis[controllerName].GetVanBangChinhSuaHistory({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&donViDangKyDuThiId=${donViDangKyDuThiId}&heDaoTaoId=${heDaoTaoId}&hinhThucDaoTaoId=${hinhThucDaoTaoId}&name=${name}`,
  })
  return rs.isSuccess ? rs.data : { skip, take, values: [], total: 0 }
}

chinhSuaVanBangProcessor.getByKhoaThi = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  const rs = await apis[controllerName].GetVanBangDaDuyetByKhoaThiId({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&donViDangKyDuThiId=${donViDangKyDuThiId}&heDaoTaoId=${heDaoTaoId}&hinhThucDaoTaoId=${hinhThucDaoTaoId}&name=${name}`,
  })
  return rs.isSuccess ? rs.data : { skip, take, values: [], total: 0 }
}
chinhSuaVanBangProcessor.updateWithVanBang = async (data) => {
  const rs = await apis[controllerName].UpdateWithVanBang({
    method: 'post',
    responseType: 'text',
    data: { ...data, ngayCapPhat: null },
  })
  return rs
}
chinhSuaVanBangProcessor.upsert = async (data) => {
  let rs
  if (data.id) {
    rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].Create({ method: 'post', responseType: 'text', data })
  }
  return rs
}
chinhSuaVanBangProcessor.upsertForm = async (data) => {
  let rs
  const submitData = { ...data }
  const request = {}
  const formdata = new FormData()
  Object.keys(submitData).forEach((key) => {
    const value = submitData[key]
    if (value) {
      formdata.append(key, value)
    }
  })
  request.formData = true
  request.data = formdata
  if (data.id) {
    rs = await apis[controllerName].Update({
      method: 'post',
      responseType: 'text',
      ...request,
    })
    // rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].CreateWithForm({
      method: 'post',
      responseType: 'text',
      ...request,
    })
  }
  return rs
}
chinhSuaVanBangProcessor.getHistory = async (id) => {
  const rs = await apis[controllerName].GetHistory({
    param: `/${id}`,
  })
  return rs
}

chinhSuaVanBangProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default chinhSuaVanBangProcessor
